// ORG USER ROLES
export const ADMIN = 'ADMIN';
export const SHIPPER = 'SHIPPER';
export const QUOTER = 'QUOTER';

// PERMISSIONS
export const BUSINESS_DELETE = 'BUSINESS_DELETE';
export const BUSINESS_SAVE = 'BUSINESS_SAVE';
export const CARRIER_DELETE = 'CARRIER_DELETE';
export const CARRIER_SAVE = 'CARRIER_SAVE';
export const CONTACT_DELETE = 'CONTACT_DELETE';
export const CONTACT_SAVE = 'CONTACT_SAVE';
export const CUSTOM_FIELD_DELETE = 'CUSTOM_FIELD_DELETE';
export const CUSTOM_FIELD_SAVE = 'CUSTOM_FIELD_SAVE';
export const DIVISION_DELETE = 'DIVISION_DELETE';
export const DIVISION_SAVE = 'DIVISION_SAVE';
export const E_PRO_DELETE = 'E_PRO_DELETE';
export const E_PRO_SAVE = 'E_PRO_SAVE';
export const LOCATION_DELETE = 'LOCATION_DELETE';
export const LOCATION_SAVE = 'LOCATION_SAVE';
export const ORGANIZATION_UPDATE = 'ORGANIZATION_UPDATE';
export const ORGANIZATION_USER_DELETE = 'ORGANIZATION_USER_DELETE';
export const ORGANIZATION_USER_SAVE = 'ORGANIZATION_USER_SAVE';
export const ORG_REFERENCE_DATA_DELETE = 'ORG_REFERENCE_DATA_DELETE';
export const ORG_REFERENCE_DATA_SAVE = 'ORG_REFERENCE_DATA_SAVE';
export const PRODUCT_DELETE = 'PRODUCT_DELETE';
export const PRODUCT_SAVE = 'PRODUCT_SAVE';
export const SHIPMENT_CANCEL = 'SHIPMENT_CANCEL';
export const SHIPMENT_DELETE = 'SHIPMENT_DELETE';
export const SHIPMENT_RATE = 'SHIPMENT_RATE';
export const SHIPMENT_SAVE = 'SHIPMENT_SAVE';
export const SHIPMENT_FILE_DELETE = 'SHIPMENT_FILE_DELETE';
export const SHIPMENT_FILE_UPLOAD = 'SHIPMENT_FILE_UPLOAD';
export const SHIPMENT_INVOICE_DELETE = 'SHIPMENT_INVOICE_DELETE';
export const SHIPMENT_INVOICE_SAVE = 'SHIPMENT_INVOICE_SAVE';
export const SHIPMENT_NOTIFICATION_RECIPIENT_DELETE =
  'SHIPMENT_NOTIFICATION_RECIPIENT_DELETE';
export const SHIPMENT_NOTIFICATION_RECIPIENT_SAVE =
  'SHIPMENT_NOTIFICATION_RECIPIENT_SAVE';
export const USER_RESET_PASSWORD = 'USER_RESET_PASSWORD';
